import React, {Component} from "react"
import PropTypes from "prop-types"
import styled, {css} from "styled-components"

import id from "@irati/utils/id"
import {greys} from "@irati/ui/src/global/colors"
import ButtonBase from "@irati/ui/src/Button"
import Flex from "@irati/ui/src/Flex"
import {minWidthMedia} from "@irati/ui/src/global/media"
import {injectIntl} from "@irati/utils/lang"
import {formatAnswerText} from "@irati/insights/utils/string"

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  position: relative;
`

const Button = styled(ButtonBase)`
  border-radius: 0;
  border-right: 0;

  ${({theme, selected}) =>
    selected &&
    css`
      background-color: ${theme.colors.primary2};
      color: ${theme.colors.utility.white};
    `}

  &:first-of-type {
    border-radius: 25px 0 0 25px;
  }
  &:last-of-type {
    border-radius: 0 25px 25px 0;
    border-right: 2px solid ${({theme}) => theme.colors.primary2};
  }

  ${({theme}) => theme.mediaQueries.maxWidthMedia.tablet`
    padding: ${theme.spacing.one};
  `}
`

const Label = styled.div`
  font-size: 11px;
  font-weight: normal;
  margin: 10px 0;
  text-transform: uppercase;
  color: ${greys.medium};

  ${minWidthMedia.tablet`
    font-size: 14px;
  `}
`

class Likert extends Component {
  static propTypes = {
    answers: PropTypes.array.isRequired,
    answerQuestion: PropTypes.func.isRequired,
    submittedAnswer: PropTypes.object
  }
  static defaultProps = {
    submittedAnswer: {}
  }

  state = {}

  render() {
    const idNamespace = id("Likert", this.props)
    const {answers, submittedAnswer, answerQuestion} = this.props
    /** Answer buttons */
    const answerButtons = answers.map((answer, index) => (
      <Button
        id={id(`answer-${answer.value}`, idNamespace)}
        large
        full
        key={index}
        selected={submittedAnswer.value === answer.value}
        onClick={(e) => {
          e.currentTarget.blur()
          answerQuestion(answer)
        }}>
        {answer.value}
      </Button>
    ))

    return (
      <Wrapper
        id={idNamespace}
        ref={(ref) => {
          this.ref = ref
        }}>
        <Flex>{answerButtons}</Flex>
        <Flex justifyContent="space-between">
          <Label id={id("left-label", idNamespace)}>{formatAnswerText(this, answers[0])}</Label>
          <Label id={id("right-label", idNamespace)}>{formatAnswerText(this, answers[answers.length - 1])}</Label>
        </Flex>
      </Wrapper>
    )
  }
}

export default injectIntl(Likert, {withRef: true})
